export const CLOUD_EXERCISE = 'CloudExercise';
export const EXPORTED_EXERCISES = [CLOUD_EXERCISE];